export const locale = {
  lang: 'pt',
  data: {
    TOOLBAR: {
      ACCOUNT_AREA: 'Tipo de conta',
      ACCOUNT_AREAS: { CUSTOMER: 'Área do cliente', LABORATORY: 'Área do laboratório' },
      API_CREDENTIALS: 'Chaves de API',
      APPLICATION_SETTINGS: 'Configurações do aplicativo',
      COLOR_THEMES_TITLE: 'Tema',
      COLOR_THEMES: { LIGHT: 'Claro', DARK: 'Sombrio', SYSTEM: 'Sistema' },
      LOGOUT: 'Cantar',
      MY_ACCOUNT: 'Minha conta',
      USER_MANAGEMENT: 'Gestão de usuários',
    },
  },
};
